/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
import { assert } from "@fluidframework/core-utils/internal";
/**
 * Monitors a Container's DeltaManager, notifying listeners when all ops have been processed
 * that were known at the time the monitor was created.
 */
export class CatchUpMonitor {
    /**
     * Create the CatchUpMonitor, setting the target sequence number to wait for based on DeltaManager's current state.
     */
    constructor(deltaManager, listener) {
        this.deltaManager = deltaManager;
        this.listener = listener;
        this.caughtUp = false;
        this.opHandler = (message) => {
            if (!this.caughtUp && message.sequenceNumber >= this.targetSeqNumber) {
                this.caughtUp = true;
                this.listener();
            }
        };
        this._disposed = false;
        this.targetSeqNumber = this.deltaManager.lastKnownSeqNumber;
        assert(this.targetSeqNumber >= this.deltaManager.lastSequenceNumber, 0x37c /* Cannot wait for seqNumber below last processed sequence number */);
        this.deltaManager.on("op", this.opHandler);
        // Simulate the last processed op to set caughtUp in case we already are
        this.opHandler({ sequenceNumber: this.deltaManager.lastSequenceNumber });
    }
    /**
     * {@inheritDoc @fluidframework/core-interfaces#IDisposable.disposed}
     */
    get disposed() {
        return this._disposed;
    }
    /**
     * {@inheritDoc @fluidframework/core-interfaces#IDisposable.dispose}
     */
    dispose() {
        if (this._disposed) {
            return;
        }
        this._disposed = true;
        this.deltaManager.off("op", this.opHandler);
    }
}
//# sourceMappingURL=catchUpMonitor.js.map